/**
The main entry point for Homepage.
Referenced by index.liquid templates.
* */
import React from 'react';
import ReactDOM from 'react-dom';
import Storage from '@outdoor-voices/ui/dist/utils/Storage';
import { COOKIES } from './config/constants';
import { retailHomePageView } from './utils/retail';
import Homepage from './apps/homepage/Homepage';
import OVApp from './utils/OVContext';
import { jsx as _jsx } from "react/jsx-runtime";

var initHomepage = function initHomepage() {
  // OVU
  var storage = new Storage();
  var fromOVUCreate = JSON.parse(storage.get(COOKIES.OVU_CREATE));
  storage.remove(COOKIES.OVU_CREATE);

  if (fromOVUCreate) {
    window.location.assign('/account');
    return false;
  }

  var rootEl = document.getElementById('homepage');
  ReactDOM.render( /*#__PURE__*/_jsx(OVApp, {
    children: /*#__PURE__*/_jsx(Homepage, {
      loadingHTML: rootEl.innerHTML
    })
  }), rootEl);
  return true;
};

initHomepage();
retailHomePageView();